import { gql } from 'graphql-request';

export const getBlogs = gql`
  query GetBlogs(
    $page: Int = 1
    $pageSize: Int = 4
    $published: Boolean
    $langCode: String
    $ordering: String
  ) {
    getBlogs(
      page: $page
      pageSize: $pageSize
      published: $published
      langCode: $langCode
      ordering: $ordering
    ) {
      count
      next
      previous
      results {
        id
        date
        title
        slug
        description
        body
        published
        language {
          langCode
        }
      }
      totalPages
    }
  }
`;

export const getBlogsShort = gql`
  query GetBlogsShort(
    $page: Int = 1
    $pageSize: Int = 4
    $published: Boolean
    $langCode: String
    $ordering: String
    $all: Boolean = false
  ) {
    getBlogsShort(
      page: $page
      pageSize: $pageSize
      published: $published
      langCode: $langCode
      ordering: $ordering
      all: $all
    ) {
      count
      next
      previous
      results {
        title
        slug
        langCode
      }
      totalPages
    }
  }
`;

export const getBlog = gql`
  query GetBlog($slug: String!) {
    getBlog(slug: $slug) {
      id
      date
      title
      slug
      description
      body
      published
      language {
        langCode
      }
    }
  }
`;

export const createBlog = gql`
  mutation CreateBlog($input: BlogInput!) {
    createBlog(input: $input) {
      id
      date
      title
      slug
      description
      body
      published
      language {
        langCode
      }
    }
  }
`;

export const updateBlog = gql`
  mutation UpdateBlog($slug: String!, $input: BlogInput!) {
    updateBlog(slug: $slug, input: $input) {
      id
      date
      title
      slug
      description
      body
      published
      language {
        langCode
      }
    }
  }
`;

export const deleteBlog = gql`
  mutation DeleteBlog($slug: String!) {
    deleteBlog(slug: $slug)
  }
`;
